import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withAsyncActions } from 'react-async-client';

import { fullAutoOptions } from 'constants/asyncClient';
import { getApprovalPerson } from 'actions/asyncActions';
import { getFullName } from 'helpers/fieldsHelpers';
import { openModalApprovePerson, openModalRejectPerson } from 'actions/modalActions';
import SidebarContainer from '../../SidebarContainer';
import ApprovalPersonGeneral from './fields/ApprovalPersonGeneral';
import ApprovalLetter from '../ApprovalLetter';
import ApprovalComments from '../ApprovalComments';
import ApprovalStatus from '../ApprovalStatus';
import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';
import { ApprovalDocuments } from '../ApprovalDocuments';

@connect(null, { openModalApprovePerson, openModalRejectPerson })
@withAsyncActions({
    getApprovalPerson: getApprovalPerson.withPayload(({ id }) => ({ id }))
}, fullAutoOptions)
export default class ApprovalPersonSidebarView extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        getApprovalPerson: PropTypes.object.isRequired,
        openModalApprovePerson: PropTypes.func.isRequired,
        openModalRejectPerson: PropTypes.func.isRequired
    };

    getFooter = (person) => (
        <ApprovalButtons
            selected={person}
            approve={ () => this.props.openModalApprovePerson([person]) }
            reject={ () => this.props.openModalRejectPerson([person]) }
        />
    )

    render() {
        const { params, getApprovalPerson: { data: person, meta } } = this.props;

        const title = meta.success ? getFullName(person, true) : params.title;
        const footer = meta.success && person.inwork && this.getFooter(person);

        return (
            <SidebarContainer meta={meta} title={title} footer={footer}>
                { meta.success && (
                    <div className="sidebar-approval-person">
                        <ApprovalPersonGeneral person={person} />
                        <ApprovalLetter letter={person.letter} />
                        <ApprovalComments comments={person.comments} />
                        <ApprovalStatus {...person} />
                        <ApprovalDocuments documents={person.documents} />
                    </div>
                )}
            </SidebarContainer>
        );
    }
}
